import { PUBLIC_PREFIX } from 'constants/images'

export const REAL_STUDENT_REVIEWS_TAB = {
  id: 'real-student-reviews',
  title: 'Real Student Reviews',
}

export const REAL_STUDENT_REVIEWS_S3_PATH = `${PUBLIC_PREFIX}/video-review`

export const VIDEO_REVIEW_PROCESSING_POLL_INTERVAL_MS = 2500

export const VIDEO_REVIEW_PROCESSING_POLL_MAX_INTERVAL_MS = 30000
